module.exports = __webpack_public_path__ + "static/media/FOX.cf7f05b9.png";